import { darken } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  sideMenuContainer: {
    marginTop: 4,
    flexBasis: '15%',
    flexGrow: 1,
    maxWidth: '255px',
    minWidth: '255px',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },
  groupHeaderContainer: {
    borderBottom: '1px solid',
    borderColor: darken(theme.palette.tx.primary, 0.8),
  },
  navGroupHeader: {
    color: darken(theme.palette.tx.primary, 0.6),
    fontSize: '14px',
    minHeight: 32,
  },
  navLink: {
    opacity: 0.7,
    paddingLeft: 8,
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    minHeight: 47,
    gap: 7,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '14px',
    lineHeight: '27px',
    color: theme.palette.tx.primary,
    cursor: 'pointer',
    borderRadius: theme.spacing(1),
    transition: 'all linear 0.2s',
    border: '1px solid transparent',
    '&:not([aria-disabled="true"]):hover': {
      opacity: 1,
      textDecoration: 'none',
    },
    '&.active': {
      opacity: 1,
      border: `1px solid ${darken(theme.palette.tx.primary, 0.8)}`,
      backgroundColor: theme.palette.bg.secondary.default,
      color: theme.palette.tx.primary,
      borderRadius: theme.spacing(1),
      '&:hover, &:focus': {
        color: theme.palette.tx.primary,
        textDecoration: 'none',
      },
    },

    '&[aria-disabled=true]': {
      cursor: 'not-allowed',
      opacity: 0.3,
      position: 'relative',
    },
  },
}));
